import { useGetPortfolioAnalytics } from "api/overview/useGetPortfolioAnalytics";
import { getFetchPolicyOptions } from "api/utils";
import { ImpersonationBanner } from "components/ImpersonationBanner/ImpersonationBanner";
import { useGetContractIdData } from "providers/ContractIdProvider";
import { useKeycloak } from "providers/KeycloakProvider";
import { Outlet, useParams } from "react-router-dom";
import { PortfolioNavigationHeader } from "./PortfolioNavigationHeader/PortfolioNavigationHeader";

export const PortfolioNavigationHeaderLayout = () => {
  const { impersonating } = useKeycloak();
  const { portfolioId } = useParams();
  const portfolioIdNr = portfolioId ? parseInt(portfolioId, 10) : undefined;

  // ✅ This query will now run ONCE per portfolio load,
  // stay cached, and not be cancelled when navigating between tabs
  const { linkedContact } = useKeycloak();
  const { selectedContactId } = useGetContractIdData();

  const currentContactId = selectedContactId || linkedContact;
  const cacheKey = `cacheKeyForPositionsAndFigures_${currentContactId}`;

  const { fetchPolicy, onCompleted } = getFetchPolicyOptions(cacheKey);

  const { data, loading } = useGetPortfolioAnalytics(portfolioIdNr, cacheKey, {
    fetchPolicy,
    onCompleted,
  });
  return (
    <div className="flex flex-col h-full">
      {impersonating && <ImpersonationBanner />}
      <PortfolioNavigationHeader />
      <Outlet />
    </div>
  );
};
